import { render, staticRenderFns } from "./FuturePriceTier.vue?vue&type=template&id=6f873949&scoped=true&"
import script from "./FuturePriceTier.vue?vue&type=script&lang=js&"
export * from "./FuturePriceTier.vue?vue&type=script&lang=js&"
import style0 from "./FuturePriceTier.vue?vue&type=style&index=0&id=6f873949&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f873949",
  null
  
)

component.options.__file = "FuturePriceTier.vue"
export default component.exports